const MAPPING_BRAND_LOGO = {
  DN: 'deenee.png',
  ES: 'eversense.png',
  FL: 'fineline.png',
  SM: 'smart.png',
  TM: 'tomi.png',
  TS: 'tros.png',
  VV: 'vivite.png',
  BE: 'benice.png',
  HT: 'happytail.png',
}

export function getBrandLogoUrl(materialMrp : string) {
  const domain = window.location.origin;
  const brand = (materialMrp && materialMrp.substring(0, 2)) as keyof typeof MAPPING_BRAND_LOGO;
  return domain + `/images/${MAPPING_BRAND_LOGO[brand]}`;
}